import moment from 'moment'

export function getDelimiterREByDelimiter(delimiter) {
  return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g')
}

export function stripDelimiters(value, delimiter, delimiters) {
  // single delimiter
  if (delimiters.length === 0) {
    var delimiterRE = delimiter ? getDelimiterREByDelimiter(delimiter) : ''
    return value.replace(delimiterRE, '')
  }

  // multiple delimiters
  delimiters.forEach(function (current) {
    current.split('').forEach(function (letter) {
      value = value.replace(getDelimiterREByDelimiter(letter), '')
    })
  })

  return value
}

function getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters) {
  var oldRawValue, newRawValue, lengthOffset

  oldRawValue = stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters)
  newRawValue = stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters)
  lengthOffset = newRawValue.length - oldRawValue.length

  return (lengthOffset !== 0) ? (lengthOffset / Math.abs(lengthOffset)) : 0
}

export function getNextCursorPosition(prevPos, oldValue, newValue, delimiter, delimiters) {
  // If cursor was at the end of value, just place it back.
  // Because new value could contain additional chars.
  if (oldValue.length === prevPos) {
    return newValue.length
  }
  return prevPos + getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters)
}

export function setSelection(element, position, document) {
  if (!element || !element.current) {
    return
  }
  if (document.activeElement !== element.current) {
    return
  }
  // cursor is already in the end
  if (element.current.value && element.current.value.length <= position) {
    return
  }

  if (element.current.createTextRange) {
    let range = element.current.createTextRange()

    range.move('character', position)
    range.select()
  } else {
    try {
      element.current.setSelectionRange(position, position)
    } catch (e) {
      // eslint-disable-next-line
      console.warn('The input element type does not support selection')
    }
  }
}

export class Formatter {
  constructor(maxLength) {
    this.delimiter = ''
    this.prefix = ''
    this.delimiters = []
    this.maxLength = maxLength
  }

  init() {
    this.delimiterRE = this.delimiter ? new RegExp('\\' + this.delimiter, 'g') : ''
  }

  format(raw) {
    return raw ? raw.toString() : ''
  }
  getRawValue(value) {
    let rawValue = value
    if (this.delimiter || this.delimiters.length > 0) {
      rawValue = stripDelimiters(rawValue, this.delimiter, this.delimiters)
    }
    if (this.maxLength) {
      rawValue = rawValue.substring(0, this.maxLength)
    }
    return rawValue
  }
}
export class NumberFormatter extends Formatter {
  constructor(maxLength) {
    super(maxLength)
  }

  format(raw) {
    raw = super.format(raw)
    raw = raw.replace(/[^\d]/g, '')
    return raw
  }

  getRawValue(value) {
    let raw = super.getRawValue(value)
    return this.format(raw)
  }
}
export class DecimalFormatter extends Formatter {
  constructor(decimalDelimiter, decimalLength) {
    super()
    this.decimalDelimitter = decimalDelimiter || ','
    this.decimalLength = decimalLength
  }

  format(raw) {
    raw = super.format(raw)
    raw = raw.replace(/[^\d.]/g, '')
    raw = raw.replace(/[.]/, this.decimalDelimitter)
    raw = raw.replace(/[.]/g, '')
    return raw
  }

  getRawValue(value) {
    let raw = super.getRawValue(value)
    raw = raw.replace(new RegExp('\\' + this.decimalDelimitter), '.')
    raw = raw.replace(new RegExp('\\' + this.decimalDelimitter, 'g'), '')
    raw = raw.replace(/[^\d.]/g, '')
    if (raw[0] === '.') {
      raw = '0' + raw
    }
    raw = raw.replace(/^0+([^/.])/, '$1')
    return raw
  }
}

class PhoneFormatter extends Formatter {
  constructor() {
    super(10)
    this.delimiter = ' '
  }

  format(raw) {
    raw = super.format(raw)
    raw = raw.replace(/[^\d]/g, '')
    raw = raw.substring(0, this.maxLength)
    let result = '', current = ''

    for (let i = 0, iMax = raw.length; i < iMax; i++) {
      current = raw.charAt(i)
      if (i % 2 === 0 && i !== 0 ) {
        result += this.delimiter
      }
      result += current
    }
    return result
  }

  getRawValue(value) {
    let raw = super.getRawValue(value)
    raw = raw.replace(/[^\d]/g, '')
    return raw
  }
}

export function getPostDelimiter(value, delimiter, delimiters) {
  // single delimiter
  if (delimiters.length === 0) {
    return value.slice(-delimiter.length) === delimiter ? delimiter : ''
  }

  // multiple delimiters
  var matchedDelimiter = ''
  delimiters.forEach(function (current) {
    if (value.slice(-current.length) === current) {
      matchedDelimiter = current
    }
  })

  return matchedDelimiter
}

export const phoneFormatter = new PhoneFormatter()

export const MoneyFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })

export const round2Digits = (value) => Number(Math.round(Number(value + 'e+2')) + 'e-2')

export const generateDeclarationMonthList = (start, end, declarations, record) => {
  if(!start){
    start = moment().startOf('month').utcOffset(0, true)
  }
  const minActiveDate = moment().subtract(2, 'months').startOf('month').utcOffset(0, true) 
  const validationStartMonth = moment(record.validateDate).subtract(1, 'months').startOf('month').utcOffset(0, true) 
  const startBabysittingMonth = moment(record.startDate, 'YYYYMMDD').startOf('month').utcOffset(0, true) 
  const declarationStartMonth = moment.max(validationStartMonth, startBabysittingMonth).utcOffset(0, true) 
  const toDate = moment.max(declarationStartMonth, end).utcOffset(0, true) 
  const expirationMonth = moment(record.archivedDate).utcOffset(0, true).startOf('month')
  const fromDate = moment.min(start, expirationMonth).utcOffset(0, true) 
  const duration = fromDate.diff(toDate, 'months', false)
  const listMonths =[]

  if(duration < 0) {
    return {
      offset: toDate,
      listMonths,
      more: false
    }
  }
  for(let i = 0; i <= duration; i++) {
    const date = moment(fromDate).subtract(i, 'months').startOf('month').add(1,'days')
    const period = date.format('YYMM')
    const declarationsFiltered = declarations ? declarations.filter(d => d.period === period) : []
    const declaration = declarationsFiltered.length === 1 ? declarationsFiltered[0] : null
    const canDeclare = date.isSameOrAfter(minActiveDate)
      && (!declaration || declaration.status === 'CREATED')
      && record.status === 'VALIDATED'
    const monthDeclaration = {
      date,
      period,
      recordId: record._id,
      canDeclare
    }
    if(declaration) {
      monthDeclaration.declaration = declaration
    }
    listMonths.push(monthDeclaration)
  }
  return {
    listMonths,
    offset: toDate,
    more: toDate.isAfter(declarationStartMonth)
  }
}

const createHiddenElement = () => {
  const el = document.createElement('p')
  el.style.opacity = 0
  document.body.append(el);
  return el
}

export const htmlEncode = (text) => {
  const el = createHiddenElement()
  el.innerText = text
  const html = el.innerHTML.replace(/\"/g, "&quot;").replace(/\\/g, "&#x5C;")
  el.remove()
  return html
}

export const htmlDecode = (html) => {
  const el = createHiddenElement()
  el.innerHTML = html
  const text = el.innerText
  el.remove()
  return text
}


